export const TRACKED_EVENTS = [
  "gift_created",
  "gift_claimed",
  "gift_link_copied",
  "gift_link_viewed",
  "gift_link_refunded",
  "deposit_failed",
  "otc_deal_initiated",
  "swap_failed",
  "swap_cancelled",
  "otc_confirmed",
  "withdrawal_failed",
  "contact_created",
  "contact_updated",
  "contact_deleted",
  "contact_transfer_clicked",
  "contact_selected_as_recipient",
  "contact_search_performed",
  "contact_modal_opened",
  "contact_create_from_transfer",
  "swap_quote_requested",
  "swap_quote_rejected",
  "swap_abandoned",
  "send_freshness_warning_shown",
  "send_freshness_warning_confirmed",
  "send_freshness_warning_proceeded",
] as const

export type TrackedEvent = (typeof TRACKED_EVENTS)[number]

// Internal-only signal. It is intentionally not in TRACKED_EVENTS because the
// canonical flow event has already been sent directly to the analytics sinks.
export const JOURNEY_COMPLETED_EVENT = "internal_journey_completed"

export type JourneyCompletedPayload = Readonly<{
  flow: string
  journey_id: string
  transaction_id?: string
}>
